<template>
  <div class="info">
    <div class="container">
      <div class="info__wrapper">
        <div class="info__left">
          <h2>{{ t('home.info.title') }}</h2>
          <p>
            <span>{{ t('home.info.text1') }}</span>
            <span>{{ t('home.info.text2') }}</span>
          </p>
        </div>
        <div class="info__right">
          <router-link :to="translations.i18nRoute({ name: 'market' })">
            {{ t('buttons.startShopping') }}
            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
              <path d="M9.5625 6.125L17.4375 14L9.5625 21.875" stroke="#008ECC" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
          <img src="@images/infoImage.png" alt="image">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.info {
  padding-top: 150px;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 150px;
  }

  &__left {
    display: flex;
    flex-direction: column;
    gap: 50px;

    & h2 {
      color: #222;
      font-size: 63px;
      font-weight: 700;
      line-height: 63px;
    }

    & p {
      display: flex;
      flex-direction: column;
      gap: 15px;

      & span {
        color: #666;
        text-align: justify;
        font-size: 16px;
        font-weight: 600;
        line-height: 27px;
      }
    }
  }

  &__right {
    position: relative;

    & img {
      width: 625px;
    }

    & a {
      cursor: pointer;
      position: absolute;
      bottom: 30px;
      left: 30px;
      border-radius: 27px;
      background-color: #F3F9FB;
      box-shadow: 0 4px 7.3px 0 rgba(0, 0, 0, 0.50);
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 10px 20px;
      transition: 0.2s;

      color: #222;
      font-size: 21px;
      font-weight: 500;
      line-height: 27px;

      @include hover {
        background-color: #bebebe;
      }
    }
  }
}

@media (max-width: 1300px) {
  .info {
    &__wrapper {
      gap: 75px;
    }

    &__left {
      gap: 25px;

      & h2 {
        font-size: 48px;
      }
    }

    &__right {
      & img {
        width: 400px;
      }
    }
  }
}

@media (max-width: 1000px) {
  .info {
    &__wrapper {
      flex-direction: column;
    }
  }
}

@media (max-width: 500px) {
  .info {
    &__wrapper {
      gap: 30px;
    }

    &__left {
      & h2 {
        font-size: 32px;
      }
    }

    &__right {
      & img {
        width: 100%;
      }

      & a {
        left: 15px;
        bottom: 15px;
      }
    }
  }
}
</style>